import { render, staticRenderFns } from "./VentanaOperacionesPostuladosTerceros.vue?vue&type=template&id=73e42e73"
import script from "./VentanaOperacionesPostuladosTerceros.vue?vue&type=script&lang=js"
export * from "./VentanaOperacionesPostuladosTerceros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports